import { render, staticRenderFns } from "./ModalBusca.vue?vue&type=template&id=b67fcd9a"
import script from "./ModalBusca.vue?vue&type=script&lang=js"
export * from "./ModalBusca.vue?vue&type=script&lang=js"
import style0 from "./ModalBusca.vue?vue&type=style&index=0&id=b67fcd9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports